export default function getDomainName(url: string) {
  if (!url) return "Source";
  const parsedUrl = new URL(url);
  return parsedUrl.hostname;
}
